<template>
  <div class="registration mt-3">
    <div class="row no-gutters steps">
      <div class="col text-muted first" :class="{ active: step > 0 }">
        <small>{{ $t("names") }}</small>
      </div>
      <div class="col text-muted second" :class="{ active: step > 1 }">
        <small>{{ $t("agesex") }}</small>
      </div>
      <div class="col text-muted third" :class="{ active: step > 2 }">
        <small>{{ $t("passwords") }}</small>
      </div>
    </div>
    <div
      class="register row no-gutters justify-content-center"
      :class="{ Step1: step === 1, Step2: step === 2, Step3: step === 3 }"
    >
      <div class="p-3 col-12 col-md-6">
        <transition name="slide-fade">
          <div v-if="step === 1">
            <div>
              <div class="myfield">
                <input type="text" id="id_number" :value="id_number" />
                <label for="id_number">{{ $t("id_number") }}</label>
              </div>
            </div>
            <div :class="{ 'text-muted': step > 1 }">
              <AStep></AStep>
            </div>
          </div>
          <div v-else-if="step === 2">
            <h4 class="mb-3 text-center">{{ $t("hello") }} {{ firstname }}</h4>
            <BStep></BStep>
          </div>
          <div v-else-if="step === 3">
            <h4 class="mb-2 text-center">{{ $t("hello") }} {{ firstname }}</h4>
            <small v-if="birthdate" class="mb-3 d-block text-center">
              {{ $moment().diff($moment(birthdate), "years") }}
              {{ $t("yearsOld") }}
            </small>
            <CStep v-if="step === 3"></CStep>
          </div>
        </transition>
      </div>
      <div class="w-100"></div>
      <div class="col-12 col-md-6 pl-5 text-right">
        <button
          class="btn btn-block my-btn p-3"
          type="submit"
          @click.prevent="trySubmit"
        >
          <span v-if="step < 3">
            {{ $t("next") }}
          </span>
          <span v-else>
            {{ $t("finish") }}
          </span>
          <DoubleArrow></DoubleArrow>
        </button>
        <router-link
          :to="{ name: 'Login' }"
          class="mt-3 pr-3 d-inline-block lowercase"
        >
          {{ $t("authorize") }}
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import AStep from '@/components/Register/AStep.vue'
import BStep from '@/components/Register/BStep.vue'
import CStep from '@/components/Register/CStep.vue'

import DoubleArrow from '@/components/Icons/DoubleArrow.vue'
import { mapGetters, mapMutations } from 'vuex'
export default {
  components: {
    AStep,
    BStep,
    CStep,
    DoubleArrow
  },
  computed: {
    ...mapGetters({
      id_number: 'register/id_number',
      firstname: 'register/firstname',
      lastname: 'register/lastname',
      birthdate: 'register/birthdate',
      gender: 'register/gender',
      country_code: 'register/country_code',
      phone_number: 'register/phone_number',
      password: 'register/password',
      password_confirm: 'register/password_confirm',
      step: 'register/step'
    })
  },
  watch: {
    '$route.query': {
      deep: true,
      immediate: true,
      handler (val) {
        this.setFirstname(val.firstname)
        this.setLastname(val.lastname)
        this.setid_number(val.id_number)
        this.setGender(val.gender)
        this.setBirthdate(val.birthdate)
        this.setcountry_code(val.country_code)
        this.setphone_number(val.phone_number)
        this.setPassword(val.password)
        this.setpassword_confirm(val.password_confirm)
        this.setAgreed(val.agreed)
      }
    },
    step (val) {
      if (val === 4) {
        this.register()
      }
    }
  },
  mounted () {
    this.setNavVisible(false)
    this.setHead({ url: '/login', text: this.$t('registration') })
  },
  destroyed () {
    this.resetHead()
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError',
      setNavVisible: 'app/setNavVisible',
      setHead: 'head/set',
      resetHead: 'head/reset',
      setid_number: 'register/setid_number',
      setFirstname: 'register/setFirstname',
      setLastname: 'register/setLastname',
      setBirthdate: 'register/setBirthdate',
      setGender: 'register/setGender',
      setcountry_code: 'register/setcountry_code',
      setphone_number: 'register/setphone_number',
      setPassword: 'register/setPassword',
      setpassword_confirm: 'register/setpassword_confirm',
      setAgreed: 'register/setAgreed',
      trySubmit: 'register/trySubmit'
    }),
    async register () {
      this.errors = {}
      try {
        const params = {
          language: this.$i18n.locale,
          firstname: {},
          lastname: {},
          gender: this.gender,
          personal_number: this.id_number,
          birthdate: this.birthdate,
          phone_number: `${this.country_code}${this.phone_number}`,
          password: this.password,
          repeat_password: this.password_confirm
        }
        params.firstname[this.$i18n.locale] = this.firstname
        params.lastname[this.$i18n.locale] = this.lastname
        console.log(params)
        await this.axios.post('/api/auth/register', params)
        this.$router.push({ name: 'Login', query: { identifier: this.id_number } })
      } catch (err) {
        console.log(err)
        this.setError(err)
      }
    }
  }
}
</script>
<style lang="scss">
.registration {
  .register {
    min-width: 50vw;
    // position: absolute;
    // top: 1rem;
    // left: 50%;
    transition: all 0.3s ease-out;
    // transform: translate(-50%, -50%);
    @media only screen and (max-width: 768px) {
      min-width: 100vw;
    }
    .finished {
      opacity: 0.2;
      input {
        pointer-events: none;
      }
    }
    .my-btn {
      display: flex;
      color: #fff;
      background-image: linear-gradient(101deg, #4295ee, #3573b7);
      justify-content: space-between;
      svg {
        width: 24px;
        height: 24px;
      }
    }
  }
  .steps {
    .first {
      text-align: center;
      padding-top: 1rem;
      &::after {
        content: "";
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24) !important;
        position: absolute;
        background: #eee;
        height: 1rem;
        width: 1rem;
        border-radius: 1rem;
        top: 0;
        left: 50%;
        transform: translate(-50%, 0);
      }
      &::before {
        content: "";
        position: absolute;
        border-bottom: 1px dashed #ddd;
        height: 1px;
        width: 50%;
        border-radius: 1rem;
        top: 0.5rem;
        left: 50%;
      }
    }
    .second {
      text-align: center;
      padding-top: 1rem;
      &::after {
        content: "";
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24) !important;
        position: absolute;
        background: #eee;
        height: 1rem;
        width: 1rem;
        border-radius: 1rem;
        top: 0;
        left: 50%;
        transform: translate(-50%, 0);
      }
      &::before {
        content: "";
        position: absolute;
        border-bottom: 1px dashed #ddd;
        height: 1px;
        width: 100%;
        border-radius: 1rem;
        top: 0.5rem;
        left: 0;
      }
    }
    .third {
      text-align: center;
      padding-top: 1rem;
      &::after {
        content: "";
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24) !important;
        position: absolute;
        background: #eee;
        height: 1rem;
        width: 1rem;
        border-radius: 1rem;
        top: 0;
        left: 50%;
        transform: translate(-50%, 0);
      }
      &::before {
        content: "";
        position: absolute;
        border-bottom: 1px dashed #ddd;
        height: 1px;
        width: 50%;
        border-radius: 1rem;
        top: 0.5rem;
        left: 0;
      }
    }
    .active {
      &::after {
        background: #4295ee;
      }
    }
  }
}
</style>
<i18n>
{
  "ka": {
    "registration": "რეგისტრაცია",
    "next": "შემდეგი",
    "authorize": "ავტორიზაცია",
    "id_number": "პირადი ნომერი",
    "hello": "გამარჯობა",
    "yearsOld": "წლის",
    "names": "სახელი",
    "agesex": "სქესი/ასაკი",
    "passwords": "პაროლი",
    "finish": "დასრულება"
  },
  "en": {
    "registration": "Registration",
    "next": "Next",
    "authorize": "Login",
    "id_number": "ID",
    "hello": "Hi",
    "yearsOld": "years old",
    "names": "Names",
    "agesex": "Gender/Age",
    "passwords": "Password",
    "finish": "Finish"
  }
}
</i18n>
